import React from 'react'

const Intro1 = () => {
    return (
        <section className="intro-1 pt-2" id="home">
            <div className="row pt-5 landing">
                <div className='col-lg-6 col-md-6 col-sm-12 my-intro'>
                    <div className="p-5">
                        <h4>I'm Abhishek</h4>
                        <h6>Front-End Developer</h6>
                    </div>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 intro-image'>
                    <img src="https://drive.google.com/uc?id=1REZ5BitqgxvOAdgeuiGS2GX7Jve1w_uq" alt="Abhishek" />
                </div>
            </div>
        </section>
    )
}

export default Intro1
